import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import BoletoService from 'services/BoletoService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
	boletosContrato: [],
	loadingBoletosContrato: false,
	loadingDashboard: false,
	pagination: {
		content: [],
		totalElements: 0,
		totalPages: 0,
		currentPage: 0,
		pageSize: 10,
	},
}

export const getAll = createAsyncThunk('boleto/all',async () => {
    const response = await BoletoService.all()
    return response;
})

export const getAllPaginated = createAsyncThunk('boleto/allPaginated', async (params, { rejectWithValue }) => {
	try {
		const response = await BoletoService.paginated(params)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar boletos')
	}
})

export const atraso = createAsyncThunk('boleto/atraso',async () => {
    const response = await BoletoService.atrasado()
    return response;
})

export const getByContrato = createAsyncThunk('boleto/byContrato',async (contratoId, { rejectWithValue }) => {
	try {
		const response = await BoletoService.getByContrato(contratoId);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar boletos do contrato')
	}
})

export const cancelar = createAsyncThunk('boleto/cancelar',async (data, { rejectWithValue }) => {
	try {
		const response = await BoletoService.cancelar(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao cancelar boleto')
	}
})

export const confirmar = createAsyncThunk('boleto/confirmar',async (data, { rejectWithValue }) => {
	try {
		const response = await BoletoService.confirmar(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao confirmar boleto')
	}
})

export const reenviar = createAsyncThunk('boleto/reenviar',async (data, { rejectWithValue }) => {
	try {
		const response = await BoletoService.reenviar(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao reenviar boleto')
	}
})

export const gerarNf = createAsyncThunk('boleto/gerarnf',async (data, { rejectWithValue }) => {
	try {
		const response = await BoletoService.gerarNf(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao gerar nf')
	}
})

export const boletoSlice = createSlice({
	name: 'boleto',
	initialState,
	reducers: {
		clearBoletosContrato: (state) => {
			state.boletosContrato = [];
			state.loadingBoletosContrato = false;
		}
	},
    extraReducers: (builder) => {
		builder
			.addCase(getAll.pending, (state) => {
				state.loadingDashboard = true
			})
			.addCase(getAll.fulfilled, (state, action) => {
				state.loadingDashboard = false
				state.boletos = action.payload
			})
			.addCase(getAll.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loadingDashboard = false
			})
			.addCase(getAllPaginated.pending, (state) => {
				state.loading = true
			})
			.addCase(getAllPaginated.fulfilled, (state, action) => {
				state.loading = false
				state.pagination = {
					content: action.payload.content,
					totalElements: action.payload.totalElements,
					totalPages: action.payload.totalPages,
					currentPage: action.payload.number,
					pageSize: action.payload.size,
				}
			})
			.addCase(getAllPaginated.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(getByContrato.pending, (state) => {
				state.loadingBoletosContrato = true
			})
			.addCase(getByContrato.fulfilled, (state, action) => {
				state.loadingBoletosContrato = false
				state.boletosContrato = action.payload
			})
			.addCase(getByContrato.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loadingBoletosContrato = false
			})
			.addCase(cancelar.pending, (state) => {
				state.loadingBoletosContrato = true
			})
			.addCase(cancelar.fulfilled, (state, action) => {
				state.loadingBoletosContrato = false
				state.redirect = '/app/boleto/default'
				state.edicao = action.payload
			})
			.addCase(cancelar.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loadingBoletosContrato = false
			})
			.addCase(confirmar.pending, (state) => {
				state.loadingBoletosContrato = true
			})
			.addCase(confirmar.fulfilled, (state, action) => {
				state.loadingBoletosContrato = false
				state.redirect = '/app/boleto/default'
			})
			.addCase(confirmar.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loadingBoletosContrato = false
			})
			.addCase(reenviar.pending, (state) => {
				state.loadingBoletosContrato = true
			})
			.addCase(reenviar.fulfilled, (state, action) => {
				state.loadingBoletosContrato = false
				state.redirect = '/app/boleto/default'
				state.edicao = action.payload
			})
			.addCase(reenviar.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loadingBoletosContrato = false
			})
			.addCase(gerarNf.pending, (state) => {
				state.loadingBoletosContrato = true
			})
			.addCase(gerarNf.fulfilled, (state, action) => {
				state.loadingBoletosContrato = false
				state.redirect = '/app/boleto/default'
				state.nf = action.payload
			})
			.addCase(gerarNf.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.nf = false
				state.loadingBoletosContrato = false
			})
			.addCase(atraso.pending, (state) => {
				state.loadingAtraso = true
			})
			.addCase(atraso.fulfilled, (state, action) => {
				state.loadingAtraso = false
				state.atrasos = action.payload
			})
			.addCase(atraso.rejected, (state, action) => {
				state.message = action.payload
			})
	},
})

export const {
	clearBoletosContrato
} = boletoSlice.actions

export default boletoSlice.reducer